import React from "react";
import Contact from "../../Components/Contact/Contact";
import Header from "../../Components/Header/Header";
import Projects from "../../Components/Projects/Projects";
import Skills from "../../Components/Skills/Skills";
import "./Home.css";

const Home = () => {
  return (
    <div className="h-[100vh] main-container bg-neutral">
      <Header></Header>
      <Skills></Skills>
      <Projects></Projects>
      <Contact></Contact>
    </div>
  );
};

export default Home;
